import React, { useEffect, useRef, useCallback, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useCategoriesInfinite } from '../hooks/useCategoriesInfinite';
import { useTranslation } from '../contexts/LocaleContext';

interface CategoryMultiSelectProps {
  value: number[];
  onChange: (categoryIds: number[]) => void;
  disabled?: boolean;
  height?: string;
  maxHeight?: string;
  /** 'only' = выбор одной категории (передаёт массив из одного id) */
  mode?: 'only' | 'multiple';
  /** Исключить категорию из списка (например текущую при редактировании) */
  excludeId?: number;
}

export const CategoryMultiSelect: React.FC<CategoryMultiSelectProps> = ({
  value,
  onChange,
  disabled,
  height = '200px',
  maxHeight = '200px',
  mode,
  excludeId,
}) => {
  const t = useTranslation();
  const { categories, loadMore, hasMore, loading } = useCategoriesInfinite({ pageSize: 7, excludeId });
  const listRef = useRef<HTMLDivElement>(null); 
  const [init,setInit] = useState(false)

  useEffect(() => {
    const loadM = async () =>{
      await loadMore();
      setInit(true)
    }
    loadM()
  }, []);

  useEffect(() => {
    if(init){
      loadMore()
    }
  }, [init]);



  const handleScroll = useCallback(() => {
    const el = listRef.current;
    if (!el || !hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      loadMore();
    }
  }, [hasMore, loading, loadMore]);

  const toggle = (id: number) => {
    if (mode === 'only') {
      onChange([id])
      return
    }
    if (value.includes(id)) {
      onChange(value.filter((x) => x !== id));
    } else {
      onChange([...value, id]);
    }
  };

  return (
    <div
      ref={listRef}
      onScroll={handleScroll}
      className="border rounded p-2 bg-light category-multiselect-list"
      style={{ height, overflowY: 'auto', maxHeight }}
    >
      {categories.map((cat) => (
        <Form.Check
          key={cat.id}
          type="checkbox"
          id={`cat-${cat.id}`}
          label={cat.name}
          checked={value.includes(cat.id)}
          onChange={() => toggle(cat.id)}
          disabled={disabled}
          className="w-100 category-multiselect-check"
        />
      ))}
      {loading && (
        <div className="text-muted small text-center py-1">
          {t('Loading...')}
        </div>
      )}
    </div>
  );
};

export default CategoryMultiSelect;
